import './App.css';
import Navbar from './NavBar';
import StartSida from './startsida';
import OmOss from './Undersidor/omOss';
import Tjanster from './Undersidor/tjanster';
import Kontakt from './Undersidor/kontakt';
import Footer from './footer';
import Bokningsvillkor from './Undersidor/bokningsvillkor';
import Policy from './Undersidor/integritetpolicy';
import {Routes, Route, BrowserRouter } from "react-router-dom";
function App() {
  return (
    <div className="min-h-screen bg-beige-light flex flex-col">
      <BrowserRouter>
        <Navbar />

        <main className="flex-1">
          <Routes>
            <Route path="/omoss" element={<OmOss />} />
            <Route path="/tjanster" element={<Tjanster />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/bokningsvillkor" element={<Bokningsvillkor/>} />
            <Route path="*" element={<StartSida />} />
            <Route path="/integritetspolicy" element={<Policy/>} />
          </Routes>
        </main>

        {/* Footer här sen */}
<Footer/>
      </BrowserRouter>
    </div>
  );
}

export default App;
